// extracted by mini-css-extract-plugin
export default {"next-required-event-container":"next-required-event-container-a41a","next-required-event":"next-required-event-f3cd"};